// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"66":"36198397","118":"d1cb9a9e","212":"ea07c38e","643":"87cc9c78","842":"e3317608"}[chunkId] + ".css";
};